import React, { forwardRef, } from 'react';
import { Box } from '../Box';
import { Field } from '../fields/Field';
import { Input, StyledFrontIcon } from '../fields/components/CommonInput';
import { useUniqueId } from '../utils/id';
export const CurrencyInput = forwardRef(function CurrencyInput({ id: idProp, placeholder, name, value, decimalNumber = true, onChange, onInputChange, onBlur, min, max, disabled = false, error = false, fallbackStyle, ...fieldProps }, ref) {
    const id = useUniqueId(idProp);
    const frontIcon = 'pound-regular';
    const formatCurrency = (value) => {
        const decimalIndex = value.indexOf('.');
        if (!decimalNumber) {
            return Math.trunc(Number(value)).toString();
        }
        if (decimalIndex >= 0 && value.length > decimalIndex + 1) {
            const fractionalString = value.substring(decimalIndex + 1).substring(0, 2);
            return `${value.substring(0, decimalIndex)}.${fractionalString}`;
        }
        else {
            return value;
        }
    };
    const applyMinMax = (value) => {
        const numberValue = Number(value);
        if (min && numberValue < min)
            return min.toString();
        if (max && numberValue > max)
            return max.toString();
        return value;
    };
    const handleChange = (value) => {
        if (onChange === undefined)
            return;
        const EMPTY_INPUT = '';
        if (value === EMPTY_INPUT) {
            onChange(value);
        }
        else {
            const amount = formatCurrency(value);
            const normalisedValue = applyMinMax(amount);
            onChange(normalisedValue);
        }
    };
    return (React.createElement(Field, { ...fieldProps, htmlFor: id, error: error },
        React.createElement(Box, { flex: true, alignItems: "center", justifyContent: "flex-start" },
            React.createElement(StyledFrontIcon, { "$disabled": disabled, render: frontIcon, color: "sesame" }),
            React.createElement(Input, { ref: ref, "$error": error, disabled: disabled, type: "number", id: id, name: name, placeholder: placeholder, value: value, "$frontIcon": frontIcon, "$fallbackStyle": fallbackStyle, onChange: (e) => {
                    onChange && handleChange(e.currentTarget.value);
                    onInputChange && onInputChange(e);
                }, onWheel: (e) => e.currentTarget.blur(), onBlur: onBlur }))));
});
//# sourceMappingURL=CurrencyInput.js.map